'use client';

import CircularProgress from '@mui/material/CircularProgress';

type LoadingSpinnerProps = {
  size?: number;
  color?: string;
  ariaLabel?: string;
};

export function LoadingSpinner({
  size = 14,
  color = 'var(--nn-color-primary)',
  ariaLabel = 'Loading',
}: LoadingSpinnerProps) {
  return <CircularProgress size={size} aria-label={ariaLabel} sx={{ color }} />;
}
